import React from "react";
import { Link } from "react-router-dom";
import GradientButton from "../../components/Buttons/GradientButton/GradientButton";
import StyledH2Heading from "../../common/components/styledH2Heading/StyledH2Heading";
import StyledH5Heading from "../../common/components/styledH5Heading/StyledH5Heading";



const NotFoundPage = () => {
  return (
    <>
      <div className="w-full flex justify-center items-center bg-[#000]">
        <div className="flex flex-col items-center w-full gap-5 pt-10 pb-10 lg:pb-8 text-center">
          <div className="relative flex justify-center  w-[90%] sm:w-[60%] items-center">
            <div className="w-[30%] sm:w-[15%] z-10">
              <h1 className="text-bright-yellow font-bold text-[8rem] lg:text-[150px] leading-none">
                4
              </h1>
            </div>
            <div className="w-[50%] sm:w-[30%] min-w-[120px] md:min-[400px] relative">
              <img
                src="/assets/404.gif"
                alt="404 Gif"
                className=" w-full h-full ml-[22%]"
              />
            </div>
            <div className="w-[30%] sm:w-[15%]  z-10">
              <h1 className="text-bright-yellow font-bold text-[8rem] lg:text-[150px] leading-none">
                4
              </h1>
            </div>
          </div>
          <div>
            <StyledH2Heading fontColor="text-white">Oops!</StyledH2Heading>
            <StyledH5Heading fontColor="text-white">
              Error, page not found
            </StyledH5Heading>
          </div>
          <Link to="/">
            <GradientButton fontColor="px-[40px]" children={"Go Back Home"} />
          </Link>
        </div>
      </div>
      <div>
      </div>
    </>
  );
};

export default NotFoundPage;
